import { ISnackbarProps } from '@marqvision/mds/core/Snackbar';
import { MDSToastSnackbar } from '@marqvision/mds/core';
import { EnforcementResponse } from '~/apis/detection';
import { ListingsListingsProtocolsUpdateToArchivedResponse } from '~/swagger/data-contracts';

export const getActionToastMessage = (count: number, name?: string | null, action = 'requested'): string => {
  if (!name) {
    return `${count} listing${count > 2 ? 's' : ''} have been ${action}`;
  }

  let result: string;
  if (name.length > 50) {
    result = `‘${name.substring(0, 50)}...’`;
  } else {
    result = `‘${name}...’`;
  }

  if (count > 1) {
    result = `${result} and ${count - 1} more listing${count > 2 ? 's' : ''} have been ${action}.`;
  }

  return result;
};
export const handleEnforceToast = (param: {
  response: EnforcementResponse;
  callback?: (requestId: number) => void;
}): void => {
  const { response, callback } = param;
  const restImages = response.listing_image_list
    ? [...Array(response.affected - response.listing_image_list.length).keys()].map((i) => String(i))
    : [];
  const toastProps: ISnackbarProps = {
    type: 'succeed',
    images: [...(response.listing_image_list || []), ...restImages],
    title: 'Enforcement requested',
    message: getActionToastMessage(response.affected, response.listing_title),
  };

  const requestId = response.request_id;
  if (callback && requestId) {
    toastProps.actionButton = {
      dismissBefore: true,
      text: 'Undo',
      event: () => callback(requestId),
    };
  }

  MDSToastSnackbar(toastProps);
};

export const handleArchiveDismissToast = (param: {
  actionTitle: 'Archived' | 'Dismissed';
  response: ListingsListingsProtocolsUpdateToArchivedResponse;
  callback?: (requestId: number) => void;
}): void => {
  const { response } = param;
  const listingImageList = response.listing_image_list || [];
  const restImages = [...Array(response.affected - listingImageList.length).keys()].map((i) => String(i));
  MDSToastSnackbar({
    type: 'succeed',
    title: param.actionTitle,
    images: [...listingImageList, ...restImages],
    message: getActionToastMessage(response.affected, response.listing_title, param.actionTitle.toLocaleLowerCase()),
  });
};
